import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Container } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js"; 
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      {/* home */}

      <div >
        {/* <div
          className="d-flex justify-content-center"
          style={{ background: "#fdca40" }}
        >
         <p className="p-2 m-0 text-center">
            Start with free trial of <b>SeoBix!</b>-boost your SEO game&nbsp;&nbsp; <Button size="sm" variant="success">Know More</Button>
          </p>
        </div> */}
        <Nav />
      </div>
      {/* start */}
      <div className="container p-0">
        <div className="mt-md-5 mt-3">
          <div className="row  mx-md-0 mx-3  mt-sm-3">
            <div className="col-md-1 "></div>
            <div className="col m-0 p-0">
              <div className="container m-0 p-0">
                <h4 className="text-center ">Privacy Policy</h4>

                <section className="mb-4">
                  <h5>1. Introduction</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    This Privacy Policy explains how SeoBix (
                    <a
                      href="https://www.SeoBix.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://www.SeoBix.com
                    </a>
                    ) collects, uses, stores, discloses, and otherwise processes
                    the personal data we collect when you use and interact with
                    our websites and apps that display or link to this Privacy
                    Policy, register for an account, and use our Services.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    Please read this Privacy Policy carefully. If you do not
                    agree with the terms of this Privacy Policy, you should not
                    use our website and the Services or otherwise provide us
                    with your personal data. By using and/or accessing our
                    website and the Services or otherwise providing us with your
                    personal data, you acknowledge that you have read and
                    understood this Privacy Policy. Your use of our websites and
                    the Services is also governed by our Terms and Services.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    This Privacy Policy is effective as of the date first set
                    forth above. We may update this Privacy Policy from time to
                    time. If we make changes, we will post the updated Privacy
                    Policy on this page or another page that links to this page
                    and change the date at the top of this webpage. We encourage
                    you to look for updates and changes to this Privacy Policy
                    by checking this date when you access our website. Your
                    continued use of the website and our Services after we have
                    posted changes to this Privacy Policy without any prior
                    notice and notifications, if applicable, is deemed to be
                    your acceptance of those changes.
                  </p>
                </section>

                <section className="mb-4">
                  <h5>2. Information We Collect</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    Some of our website’s functionality can be used without
                    providing any personal data, though for using some features
                    of the Services, personal data is required. We process three
                    broad categories of personal data:
                  </p>
                  <ul>
                    <li style={{ fontSize: ".9rem" }}>
                      Information provided directly by you;
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      Information received from third parties; and
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      Information collected automatically in the database.
                    </li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h5>3. Information Provided Directly by Users</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    We collect personal information that you voluntarily provide
                    when interacting with our website. This includes:
                  </p>
                  <ul>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Contact Forms:</strong> Details such as your name,
                      email address, phone number, and any messages you submit
                      through our forms.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Account Registration:</strong> Information like
                      username, password, and additional profile details when
                      creating an account. If you register with the Services
                      through our website at{" "}
                      <a
                        href="https://www.SeoBix.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://www.SeoBix.com
                      </a>
                      , or through a separate subscription agreement with us,
                      then as part of such registration we will ask you to
                      provide certain personal data, including your name, your
                      company name, your email address, and password.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Purchases and Transactions:</strong> Billing
                      information, shipping addresses, and payment details when
                      making a purchase.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Surveys and Feedback:</strong> Responses to
                      surveys, reviews, or other forms of customer feedback.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Subscriptions:</strong> Email addresses and
                      preferences when subscribing to newsletters or updates.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Identity Verification:</strong> In some cases (for
                      example if you request a refund), we may ask you to
                      provide us with information to verify your identity in
                      accordance with applicable law.
                    </li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h5>4. Information Received from Third Parties</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    We may collect personal information about you from trusted
                    third-party sources to improve our services and provide a
                    seamless user experience. This includes:
                  </p>
                  <ul>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Business Partners:</strong> Information shared by
                      partners to help tailor our services.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Social Media Platforms:</strong> Data from social
                      networks when you interact with our accounts or use social
                      login features.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Analytics Providers:</strong> Insights from tools
                      like Google Analytics to understand user behavior,
                      preferences, and trends.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Marketing Affiliates:</strong> Contact details and
                      other relevant information provided by affiliates or
                      referral programs.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Publicly Available Data:</strong> Information from
                      public databases or directories relevant to our services.
                    </li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h5>5. Data Retention</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    This Data Retention Policy outlines the guidelines for
                    retaining, archiving, and securely disposing of data
                    collected and managed by our organization. It ensures
                    compliance with applicable laws, protects sensitive
                    information, and maintains operational efficiency. We retain
                    your personal data for as long as reasonably necessary to
                    provide the Services and fulfil the transactions you have
                    requested, for complying with our all legal obligations or
                    other legitimate business purposes, such as maintaining
                    business and financial records and resolving disputes,
                    maintaining security, detecting and preventing fraud and
                    abuse, and enforcing our agreements. After the applicable
                    retention period has elapsed, your personal data will be
                    anonymized or deleted. Legal Compliance If Failure to adhere
                    to this policy may result in disciplinary action and
                    potential legal consequences.
                  </p>
                  <p style={{ fontSize: ".9rem" }}>
                    This policy will be reviewed periodically to ensure
                    continued relevance and compliance with legal requirements.
                  </p>
                </section>
                <section className="mb-4">
                  <h5>6. How We Protect Your Personal Data</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    Your privacy and security are our top priorities. We
                    implement robust measures to safeguard your personal data
                    against unauthorized access, loss, alteration, or misuse.
                    Here’s how we protect your information:
                  </p>
                  <ul>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Encryption:</strong> All sensitive data is
                      encrypted during transmission and storage to ensure it
                      remains secure and confidential.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Access Control:</strong> We use role-based access
                      control, ensuring only authorized personnel can access
                      your data.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Secure Infrastructure:</strong> Our servers and
                      systems are protected by firewalls, antivirus software,
                      and regular vulnerability assessments.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Data Minimization:</strong> We collect and retain
                      only the necessary information to provide our services,
                      reducing exposure to risks.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Regular Audits:</strong> We conduct routine
                      security audits and penetration testing to identify and
                      address potential vulnerabilities.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Compliance:</strong> We adhere to industry best
                      practices and legal standards, including GDPR, CCPA, and
                      other applicable data protection laws.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Training:</strong> Our team undergoes regular
                      training on data security and privacy protocols to stay
                      updated on evolving threats.
                    </li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h5>7. Eligibility to Use the Site and Services</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    To use the Site or Services, you must meet the following
                    conditions:
                  </p>
                  <ul>
                    <li style={{ fontSize: ".9rem" }}>
                      You must be at least 18 years old, have reached the legal
                      age of majority in your jurisdiction, or have the consent
                      of a parent or guardian if you are underage.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      You must have the legal capacity to understand, accept,
                      and adhere to these Terms.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      You cannot use the Services if:
                      <ul>
                        <li style={{ fontSize: ".9rem" }}>
                          You are not legally old enough to enter into a binding
                          agreement with SeoBix.
                        </li>
                        <li style={{ fontSize: ".9rem" }}>
                          Your use of the Services would violate any applicable
                          laws in India or your country of residence.
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <p style={{ fontSize: ".9rem" }}>
                    By continuing to use the Site or Services, you confirm that
                    you meet these criteria. We encourage you to save or print a
                    copy of these Terms for your records.
                  </p>
                </section>

                <section className="mb-4">
                  <h5>8. Adhere to Applicable Technology Laws</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    We are committed to conducting our operations in full
                    compliance with all applicable laws, regulations, and
                    industry standards related to technology. This includes, but
                    is not limited to:
                  </p>
                  <ul>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Data Protection Laws:</strong> Compliance with
                      data privacy regulations such as the General Data
                      Protection Regulation (GDPR), California Consumer Privacy
                      Act (CCPA), and other regional laws to safeguard user
                      data.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Intellectual Property Laws:</strong> Respecting
                      copyrights, trademarks, and patents to ensure ethical use
                      of intellectual property.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Cybersecurity Regulations:</strong> Adhering to
                      standards and best practices for securing user data and
                      preventing cyber threats.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Accessibility Standards:</strong> Ensuring our
                      digital platforms comply with the Web Content
                      Accessibility Guidelines (WCAG) to provide equitable
                      access for all users, including those with disabilities.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Consumer Protection Laws:</strong> Following fair
                      business practices, including transparency in advertising,
                      sales, and handling consumer information.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Export and Trade Compliance:</strong> Ensuring all
                      technology products and services adhere to export control
                      laws and trade regulations. We continually review and
                      update our practices to remain aligned with evolving legal
                      requirements, demonstrating our commitment to ethical and
                      lawful operations in the tech industry.
                    </li>
                  </ul>
                </section>
                <section class="mb-4">
                  <h5>9. Intellectual Property Rights Protection</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    We are committed to upholding and protecting intellectual
                    property rights in all forms, including but not limited to
                    copyrights, trademarks, patents, trade secrets, and other
                    proprietary information.
                  </p>
                  <ul>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Respect for IP:</strong> We ensure that all
                      content, products, and services adhere to applicable
                      intellectual property laws and respect the rights of
                      creators, innovators, and businesses.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Prohibition of Infringement:</strong> Any
                      unauthorized use, reproduction, distribution, or
                      modification of intellectual property belonging to others
                      is strictly prohibited.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Safeguarding Our IP:</strong> We actively monitor,
                      enforce, and safeguard our intellectual property assets
                      through appropriate legal measures and technological
                      protections.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Collaboration and Licensing:</strong> When
                      engaging in partnerships, we establish clear agreements to
                      define ownership, licensing, and usage rights to ensure
                      mutual respect for IP.
                    </li>
                    <li style={{ fontSize: ".9rem" }}>
                      <strong>Reporting Violations:</strong> We encourage
                      stakeholders to report any suspected IP infringement
                      promptly, and we commit to investigating and addressing
                      such matters in accordance with the law.
                    </li>
                  </ul>
                </section>

                <section class="mb-4">
                  <h5>10. Cookies Use</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    Cookies are stored in the website database and/or your
                    browser as small text files. They are categorized based on
                    session cookies (temporary) and persistent cookies (stored
                    for a longer duration).
                  </p>
                </section>

                <section class="mb-4">
                  <h5>11. Third-Party Cookies</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    We may use third-party cookies for analytics (e.g., Google
                    Analytics) and marketing purposes. These are subject to the
                    privacy policies of the respective providers.
                  </p>
                </section>

                <section class="mb-4">
                  <h5>12. Confidential Information</h5>
                  <p style={{ fontSize: ".9rem" }}>
                    You agree to keep all confidential information disclosed by
                    SeoBix private and secure. "Confidential Information"
                    includes, but is not limited to, proprietary data, business
                    plans, customer information, source code, trade secrets, and
                    operational details. Unauthorized sharing or disclosure of
                    such information is strictly prohibited, both during and
                    after the term of this Agreement.
                  </p>
                </section>
              </div>
            </div>

            <div className="col-md-1"></div>
          </div>
        
        </div>
      </div>
      {/* end */}
      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background: "#31393C",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default Privacy;
